import { gql } from 'graphql-tag'
import { BRIEFING_CATEGORIES } from '~/constants/briefings'

const getBriefingBySlug = (params: { category: string; slug: string }) => {
  const camelCaseSlug = params.category.replace(/-./g, (x) =>
    x[1].toUpperCase(),
  )

  const category = BRIEFING_CATEGORIES[camelCaseSlug] || null

  if (!category) return gql()

  return gql`
  query getBriefingBySlug {
    ${category}(id: "${params.slug}", idType: SLUG) {
        title
        slug
        date
        viewerCanRead
        content
        __typename
        briefings {
            publicationFrequency
            estimatedReadingTime
        }
    }
  }
  `
}

export default getBriefingBySlug
